"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeQueryData = void 0;
function normalizeQueryData(response) {
    const data = normalizeObject(response.data);
    const previousData = normalizeObject(response.previousData);
    return Object.assign(Object.assign({}, response), { data, previousData });
}
exports.normalizeQueryData = normalizeQueryData;
function normalizeObject(obj) {
    if (!obj)
        return undefined;
    const objCopy = Object.assign({}, obj);
    for (const [key, value] of Object.entries(objCopy)) {
        if (typeof value === 'object' && !Array.isArray(value)) {
            const normalizedValue = normalizeObject(value);
            if (!normalizedValue) {
                delete objCopy[key];
            }
        }
    }
    if (!Object.keys(objCopy).filter(key => key !== '__typename').length) {
        return undefined;
    }
    return objCopy;
}
//# sourceMappingURL=normalizeQueryData.js.map